// BaseCard.tsx
import React from 'react';
import { clsx } from 'clsx';

interface BaseCardProps {
  children: React.ReactNode;
  className?: string;
  overflow?: 'hidden' | 'visible' | 'auto' | 'scroll';
  variant?: 'standard' | 'past';
}

const BaseCard: React.FC<BaseCardProps> = ({ children, className = '', overflow = 'hidden', variant = 'standard' }) => {
  return (
    <div 
      className={clsx(
        'rounded-2xl shadow-custom p-7',
        `overflow-${overflow}`,
        {
            'bg-white': variant === 'standard' && !className.includes('bg-'),
            'bg-gray-50 border border-gray-200': variant === 'past',
        },
        className
      )}
    >
      {children}
    </div>
  );
};

export default BaseCard;